import React from 'react';
import { connect } from 'react-redux';
import ReportTable from '../components/Reports/ReportTable';
import AddReport from '../components/Reports/AddReport';
import Breadcrumb from '../components/Common/Breadcrumb';
import { NoPermissions } from '../components/Common/ReusableComponents/Reusable';

const Reports = ({ hasAccess }) => {
  if (!hasAccess) return <NoPermissions />;

  return (
    <React.Fragment>
      <Breadcrumb items={[{ label: 'Reports', link: '/reports' }]} />

      <ReportTable />
      <AddReport />
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const hasAccess = state?.report?.list?.error !== 'Not Authorised.';
  return { hasAccess };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Reports);
